import { DEFAULT_TRANSFERS_TABS } from '../../../Blotters/Transfers/defaults';
import type { TransfersTabProps } from '../../../Blotters/Transfers/TransfersBlotter';
import { MobileBlotterPanel, type MobileBlotterPanelProps } from './MobileBlotterPanel';

/** Placeholder-only mobile transfers content; uses `TradingPlaceholder` via `MobileBlotterPanel`. */
export function MobileTransfersBlotter(props: Omit<MobileBlotterPanelProps<TransfersTabProps>, 'defaultTabs'>) {
  return <MobileBlotterPanel<TransfersTabProps> {...props} defaultTabs={DEFAULT_TRANSFERS_TABS} />;
}
